module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function(fox) {
	fox.registerWidget('SitePage_FreeHostedGallery', {
		activate: function (params) {
			this.callParent('activate', arguments);

			if (this.isRun()) {
				return this.rwom1('#fhg').loadPhotos(params.id);
			}

			return this.wait('running').then(function () {
				this.rwom1('#fhg').loadPhotos(params.id);
			}.bind(this));
		}
	}, 'Site_Page');
})(fox);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/freeHostedGallery.js
// module id = 884
// module chunks = 4